import React from "react"
import { Address } from "~/interfaces/entities/Address"
import AddressDefault from "./addresses/AddressDefault"
import AddressUS from "./addresses/AddressUS"
import AddressCA from "./addresses/AddressCA"
import AddressGB from "./addresses/AddressGB"
import AddressZA from "./addresses/AddressZA"
import AddressJP from "./addresses/AddressJP"
import AddressNZ from "./addresses/AddressNZ"

export interface Props {
  address: Address
}

const OrderCompleteAddress: React.FC<Props> = ({ address }) => {
  switch (address.country) {
    case "US":
      return <AddressUS address={address}></AddressUS>
    case "CA":
      return <AddressCA address={address}></AddressCA>
    case "GB":
      return <AddressGB address={address}></AddressGB>
    case "ZA":
      return <AddressZA address={address}></AddressZA>
    case "JP":
      return <AddressJP address={address}></AddressJP>
    case "NZ":
      return <AddressNZ address={address}></AddressNZ>
    default:
      return <AddressDefault address={address}></AddressDefault>
  }
}

export default OrderCompleteAddress
